module.exports = __webpack_public_path__ + "static/media/checklist.8a5c12f4.svg";